import { Box, Tooltip } from "@mui/joy";
import DarkTypography from "../../../common/DarkTypography";
import DarkCard from "../../../common/DarkCard";
import { SDelete, EditIcon } from "../../../../styles/StyledMUI";
import type { BackendPermissionKey } from "../../../../contexts/app/permissions";
import { getBackendPermissionLabel } from "../../../../contexts/app/permissions";
import { groupApiPermissionsByModule } from "../../../../api/zekay/permissions";
import type { Role } from "../../../../api/auth/Auth.typed";
import IconButtonCTA from "../../../common/IconButtonCTA";
import {
  colorTokens,
  roleCardFooterActionsSx,
  roleCardTitleSx,
  rolePermissionChipSx,
  rolePermissionChipsRowSx,
  rolePermissionModuleHeadingSx,
  rolePermissionPreviewSectionsColumnSx,
} from "../../../../styles/globalStyles";

type RoleCardProps = {
  role: Role;
  canEdit: boolean;
  onEdit: (role: Role) => void;
  onDelete: (roleId: number) => void;
};

export default function RoleCard(props: RoleCardProps) {
  const { role, canEdit, onEdit, onDelete } = props;
  const previewSections = groupApiPermissionsByModule(role.permission_list || []);

  return (
    <DarkCard dense>
      <DarkTypography level="h4" sx={roleCardTitleSx}>
        {role.name}
      </DarkTypography>
      <Box sx={rolePermissionPreviewSectionsColumnSx}>
        {previewSections.length === 0 ? (
          <DarkTypography level="body-sm">Aucune permission</DarkTypography>
        ) : (
          previewSections.map((section) => (
            <Box key={section.label}>
              <DarkTypography
                level="body-xs"
                colorVariant="muted"
                sx={rolePermissionModuleHeadingSx}
              >
                {section.label}
              </DarkTypography>
              <Box sx={rolePermissionChipsRowSx}>
                {section.keys.map((perm) => (
                  <Box key={perm} sx={rolePermissionChipSx}>
                    {getBackendPermissionLabel(perm as BackendPermissionKey)}
                  </Box>
                ))}
              </Box>
            </Box>
          ))
        )}
      </Box>
      <Box sx={roleCardFooterActionsSx}>
        {canEdit && (
          <>
            <Tooltip title="Éditer">
              <IconButtonCTA
                ctaVariant="accent"
                variant="plain"
                onClick={() => onEdit(role)}
                aria-label="Éditer le rôle"
              >
                <EditIcon sx={{ color: colorTokens.accent.primary }} />
              </IconButtonCTA>
            </Tooltip>
            <Tooltip title="Supprimer">
              <IconButtonCTA
                ctaVariant="danger"
                variant="plain"
                onClick={() => onDelete(role.id)}
                aria-label="Supprimer le rôle"
              >
                <SDelete />
              </IconButtonCTA>
            </Tooltip>
          </>
        )}
      </Box>
    </DarkCard>
  );
}
